/**
 * QMS Permission checks
 */

import { useSession } from '@/hooks/useSession';

export function useQmsPermissions() {
  const { user } = useSession();
  const isAdmin = user?.postgres_roles?.includes('full_admin') || user?.postgres_roles?.includes('director');

  const canActAsQD = isAdmin || (user?.permission_strings?.includes('qmstickets.qd_approval') ?? false);
  const canActAsCEO = isAdmin || (user?.permission_strings?.includes('qmstickets.ceo_review') ?? false);
  const canCreateTickets = isAdmin || (user?.permission_strings?.includes('qmstickets.create') ?? true);
  const canEditTickets = isAdmin || (user?.permission_strings?.includes('qmstickets.edit') ?? true);
  const canChangeTicketStatus = isAdmin || (user?.permission_strings?.includes('qmstickets.status') ?? false);
  const canApproveTicketStatus = user?.permission_strings?.includes('qmstickets.approve_status') ?? false;
  const canDeleteTickets = isAdmin || (user?.permission_strings?.includes('qmstickets.delete') ?? false);
  const canAssignTickets = isAdmin || (user?.permission_strings?.includes('qmstickets.assign') ?? false);
  const canVerifyQuality = isAdmin
    || (user?.permission_strings?.includes('qmstickets.change_control') ?? false)
    || canActAsQD;

  return {
    canActAsQD,
    canActAsCEO,
    canCreateTickets,
    canEditTickets,
    canChangeTicketStatus,
    canApproveTicketStatus,
    canDeleteTickets,
    canAssignTickets,
    canVerifyQuality,
  };
}
